import React from 'react'
import './FadeLoader.css'

interface FadeLoaderProps {
  size?: number
  color?: string
}

const FadeLoader: React.FC<FadeLoaderProps> = ({ size = 60, color = '#92400e' }) => {
  const bars = Array.from({ length: 12 })
  const barWidth = size * 0.08
  const barHeight = size * 0.25

  return (
    <div className='fade-loader-container' style={{ width: size, height: size }}>
      {bars.map((_, index) => (
        <div
          key={index}
          className='fade-loader-bar'
          style={{
            transform: `rotate(${index * 30}deg) translateY(-${size * 0.35}px)`,
            animationDelay: `${index * 0.1}s`,
            backgroundColor: color,
            height: `${barHeight}px`,
            width: `${barWidth}px`,
            borderRadius: `${barWidth / 2}px`,
            marginLeft: `-${barWidth / 2}px`,
            marginTop: `-${barHeight / 2}px`
          }}
        />
      ))}
    </div>
  )
}

export default FadeLoader
